// extracted by mini-css-extract-plugin
export var animate = "HalfBGContentCard-module--animate--c9dab";
export var attribution = "HalfBGContentCard-module--attribution--0aac1";
export var attributionImage = "HalfBGContentCard-module--attribution-image--a23d1";
export var attributionWrapper = "HalfBGContentCard-module--attribution-wrapper--343f4";
export var copyGrid = "HalfBGContentCard-module--copy-grid--1937b";
export var copyLeft = "HalfBGContentCard-module--copy-left--13607";
export var copyRight = "HalfBGContentCard-module--copy-right--2fb19";
export var grey = "HalfBGContentCard-module--grey--8574c";
export var grid = "HalfBGContentCard-module--grid--33571";
export var halfBackground = "HalfBGContentCard-module--half-background--261cd";
export var image = "HalfBGContentCard-module--image--35d8c";
export var imageBackground = "HalfBGContentCard-module--image-background--38f87";
export var imageBackgroundGrid = "HalfBGContentCard-module--image-background-grid--41742";
export var imageLeft = "HalfBGContentCard-module--image-left--1d5a6";
export var imageRight = "HalfBGContentCard-module--image-right--7a651";
export var imageWrap = "HalfBGContentCard-module--image-wrap--7fe67";
export var mainImage = "HalfBGContentCard-module--main-image--de051";
export var maxWidth = "HalfBGContentCard-module--max-width--70171";
export var padTop = "HalfBGContentCard-module--pad-top--a202b";
export var sepGrid = "HalfBGContentCard-module--sep-grid--835c4";
export var testimonial = "HalfBGContentCard-module--testimonial--0f021";
export var videoPlayer = "HalfBGContentCard-module--video-player--86dc7";
export var visible = "HalfBGContentCard-module--visible--9af0c";
export var white = "HalfBGContentCard-module--white--93599";